"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _appConfigHelper = require("../../util/appConfigHelper");
var _fetchHelper = _interopRequireDefault(require("../../util/fetchHelper"));
var _environmentHelper = _interopRequireDefault(require("../../util/environmentHelper"));
var _jwtDecode = _interopRequireDefault(require("jwt-decode"));
const submitConsents = async function (consents, consentDefinitions) {
  let payload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  const API_URL = (0, _environmentHelper.default)();
  const {
    customerId
  } = (0, _jwtDecode.default)((0, _appConfigHelper.getData)('CLEENG_AUTH_TOKEN'));
  const url = "".concat(API_URL, "/customers/").concat(customerId, "/consents");
  let consentsPayload;
  if (!payload) {
    consentsPayload = consentDefinitions.map((consentDefinition, index) => {
      return {
        name: consentDefinition.name,
        version: consentDefinition.version,
        state: consents[index] ? 'accepted' : 'declined'
      };
    });
  } else {
    consentsPayload = payload;
  }
  try {
    const res = await (0, _fetchHelper.default)(url, {
      method: 'PUT',
      body: JSON.stringify({
        consents: consentsPayload
      })
    });
    const json = await res.json();
    return json;
  } catch (error) {
    return {
      errors: [error.message]
    };
  }
};
var _default = exports.default = submitConsents;